export default __webpack_public_path__ + "static/media/BQ-BO.e1df7ee0.svg";